export default "__VITE_ASSET__becd8a86__"